import { useTranslation } from "react-i18next";
import React from "react";
import { DownloadIcon } from "./downloadIcon";
import { useCertificateContext } from "@root/context/certificate-context";
import { Box, Flex, Text, Image, Button } from "@chakra-ui/react";
import { formatDateToISO } from "@root/utils/date-helper";
import defaultThumbnail from "@root/assets/images/Course Thunbnail.png";

const DEFAULT_THUMBNAIL = defaultThumbnail;

interface MobileCertificateSectionProps {
  certificate: {
    course?: {
      thumbnail?: string;
      description?: string;
      updatedAt?: string;
      id?: string;
    };
  } | null;
}

const MobileCertificateSection: React.FC<MobileCertificateSectionProps> = ({
  certificate,
}) => {
  const { fetchCertificate, isCertificateLoading } = useCertificateContext();
  const { t } = useTranslation("common");

  // Null check for safety
  if (!certificate) return null;

  return (
    <Box
      w="100%"
      borderRadius="12px"
      borderWidth="1px"
      borderColor="#CDD6DC"
      bg="white"
      overflow="hidden"
      mb="16px"
    >
      <Flex direction="row" gap="16px" p="16px">
        {/* Image */}
        <Box
          w="120px"
          h="120px"
          flexShrink={0}
          borderRadius="12px"
          overflow="hidden"
        >
          <Image
            src={certificate?.course?.thumbnail || DEFAULT_THUMBNAIL}
            objectFit="contain"
            w="100%"
            h="100%"
          />
        </Box>

        {/* Content */}
        <Flex direction="column" flex="1" gap="8px">
          {/* Title */}
          <Text
            fontSize="16px"
            fontWeight="600"
            color="#2F2F34"
            lineHeight="1.2"
            noOfLines={2}
          >
            {certificate?.course?.description || "Course Title"}
          </Text>

          {/* Completion Date */}
          <Text fontSize="14px" color="#5C6670">
            {t("certificateSection.completed")}:{" "}
            {formatDateToISO(certificate?.course?.updatedAt as any)}
          </Text>

          {/* Completion Certificate Link */}
          <Text fontSize="14px" color="#5C6670" cursor="pointer">
            {t("certificateSection.CompletionCertificate")}
          </Text>
        </Flex>
      </Flex>

      {/* Download Certificate Button */}
      <Button
        w="100%"
        h="48px"
        bg="#1819B4"
        color="white"
        borderRadius="0"
        fontSize="16px"
        fontWeight="500"
        leftIcon={<DownloadIcon boxSize={4} color="white" />}
        onClick={() =>
          fetchCertificate({
            courseId: certificate?.course?.id,
            gmtOffset: 0,
          })
        }
        isLoading={isCertificateLoading(certificate?.course?.id)}
        loadingText={t("certificateSection.download")}
        disabled={isCertificateLoading(certificate?.course?.id)}
        _hover={{ bg: "#1415A0" }}
      >
        {t("certificateSection.download")}
      </Button>
    </Box>
  );
};

export default MobileCertificateSection;
